import React, { FunctionComponent, ReactElement } from "react";
import { Theme, makeStyles, Grid, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: theme.spacing(4),
    borderRadius: theme.spacing(4),
    borderColor: theme.palette.grey[100],
    borderWidth: "2px",
    borderStyle: "solid",
  },
  leftIconContainer: {
    borderRadius: "50%",
    backgroundColor: theme.palette.grey[100],
    marginRight: theme.spacing(3),
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
}));

interface IReportBlockProps {
  title: string;
  subtitle: string;
  leftIcon?: ReactElement;
  rightIcon?: ReactElement;
}

export const ReportBlock: FunctionComponent<IReportBlockProps> = (props) => {
  const classes = useStyles();
  const { title, subtitle, leftIcon, rightIcon } = props;
  return (
    <Grid container className={classes.container} justify="space-between" alignItems="center">
      <Grid item className={classes.leftIconContainer}>
        {leftIcon}
      </Grid>
      <Grid item xs={true}>
        <Grid container direction="column">
          <Typography>
            <b>{title}</b>
          </Typography>
          <Typography>{subtitle}</Typography>
        </Grid>
      </Grid>
      <Grid item>{rightIcon}</Grid>
    </Grid>
  );
};
